import React from 'react';
import styled from 'styled-components';
import {Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
// import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';

function CodeBlock({ input }) {
  const { primary } = input;
  const language = primary.language;
  const text = primary.code_text.text;


  return (
    <div>
      <SyntaxHighlighter language={language} style={tomorrow}>
        {text}
      </SyntaxHighlighter>
    </div>
  );
}

export { CodeBlock };
